import {
    useMemo,
} from 'react'
import useOrderLink from 'app/hooks/useOrderLink/useOrderLink'
import useRequest, {
    RequestFn, RequestKeys,
} from 'app/hooks/useRequest'
import orderRequests from 'app/requests/Order/Order.requests'
import {
    OrderTypes,
} from 'app/enums/label.enums'

import SkyNetLink, {
    SizeLink, TypeLink,
} from '../SkyNetLink'

type OrderLinkData = {
    id: number,
    orderNumber: string,
    orderType: OrderTypes
}

type Props = {
    value: number,
    title?: string,
}

const defaultProps: Partial<Props> = {
    title: undefined,
}

const OrderLink = ({
    value: orderId,
    title,
}: Readonly<Props>) => {
    const {
        data,
    } = useRequest<OrderLinkData>({
        key: RequestKeys.getOrderLink,
        params: {
            orderId,
        },
        requestFunc: RequestFn.getEntity(orderRequests.getOrderLinkData),
        enabled: Boolean(orderId),
    })

    const generateOrderLink = useOrderLink()

    const link = useMemo(() => {
        return data ? generateOrderLink(data.orderNumber, data.orderType) : ''
    }, [
        data,
        generateOrderLink,
    ])

    return (
        <SkyNetLink
            link={link}
            title={title}
            text={data?.orderNumber}
            type={TypeLink.EXTERNAL}
            size={SizeLink.S}
        />
    )
}

OrderLink.defaultProps = defaultProps

export default OrderLink
